import { RolePermissionModel } from 'app/models/rolePermissionModel'
import * as React from 'react'
import { AdminIcon } from '@/modules/shared/components'

import { ControlledMenu, MenuItem, MenuDivider, SubMenu } from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import { Permissions } from 'app/constants/permissions'
import FlexView from '@/modules/shared/components/FlexView'

type PermissionsContextMenuProps = {
  id: string
  anchorPoint: { x: number; y: number } | null
  onClose: () => void
  permissions: Array<Permissions>
  role: RolePermissionModel
  translate: (text) => any
  onClickAction: (data?: any) => void
}
type PermissionsContextMenuState = {}

export class PermissionsContextMenu extends React.Component<
  PermissionsContextMenuProps,
  PermissionsContextMenuState
> {
  constructor(props: PermissionsContextMenuProps) {
    super(props)
  }

  render() {
    return (
      <ControlledMenu
        anchorPoint={this.props.anchorPoint ?? undefined}
        state={this.props.anchorPoint ? 'open' : 'closed'}
        onClose={this.props.onClose}
        onContextMenu={(e) => e.preventDefault()}
        className="tw-z-[10000]"
        portal
      >
        <SubMenu
          label={
            <span style={{ height: 25 }}>
              {this.props.translate('administrationPanel-roles.manageCompany')}
            </span>
          }
        >
          {this.renderItem(Permissions.canCreateCompany)}
          {this.renderItem(Permissions.canEditCompany)}
          {this.renderItem(Permissions.canRemoveCompany)}
        </SubMenu>
        <SubMenu
          label={this.props.translate('administrationPanel-roles.manageUser')}
        >
          {this.renderItem(Permissions.canCreateUser)}
          {this.renderItem(Permissions.canEditUser)}
          {this.renderItem(Permissions.canRemoveUser)}
        </SubMenu>
        <MenuDivider />
        {this.renderItem(Permissions.canImportFiles)}
        {this.renderItem(Permissions.canExportData)}
        {this.renderItem(Permissions.canAddDriver)}
        <MenuDivider />
        {this.renderItem(Permissions.canViewActivities)}
        {this.renderItem(Permissions.canEditActivities)}
        {this.renderItem(Permissions.canEditActivityDay)}
        {this.renderItem(Permissions.canEditGpsData)}
        <MenuDivider />
        {this.renderItem(Permissions.canViewDelegations)}
        {this.renderItem(Permissions.canEditDelegations)}
        <MenuDivider />
        {this.renderItem(Permissions.canViewBillingData)}
        {this.renderItem(Permissions.canEditBillingData)}
        <MenuDivider />
        {this.renderItem(Permissions.canViewConfiguration)}
        {this.renderItem(Permissions.canReadDatabaseLogin)}
        <MenuDivider />
        {this.renderItem(Permissions.canGenerateAttestation)}
        {this.renderItem(Permissions.canGeneratePrintouts)}
        <MenuDivider />
        {this.renderItem(Permissions.canViewAlerts)}
        {this.renderItem(Permissions.canEditAlerts)}
        <MenuDivider />
        {this.renderItem(Permissions.isDriver)}
      </ControlledMenu>
    )
  }

  private renderItem = (permission: Permissions) => {
    return (
      <MenuItem
        onClick={(event) => {
          // odpowiednik preventClose z react-contextmenu: menu zostaje otwarte,
          // żeby dało się zaznaczyć kilka uprawnień pod rząd
          event.keepOpen = true
          this.props.onClickAction(permission)
        }}
      >
        <FlexView
          style={{ height: 25 }}
          hAlignContent="left"
          vAlignContent="center"
        >
          {this.props.role[permission] && (
            <AdminIcon
              name="check"
              className="roleDiv"
              style={{ backgroundSize: 10, marginRight: 3 }}
            />
          )}
          <span style={{ marginRight: 10 }}>
            {this.props.translate(`administrationPanel-roles.${permission}`)}
          </span>
        </FlexView>
      </MenuItem>
    )
  }
}
